import { ScrollableTable, TableColumnProps } from "Components/ScrollableTable/ScrollableTable";
import i18n, { I18N_NS } from "Config/i18n";
import React from "react";
import { observer } from "mobx-react";
import { bcfViewerStore } from "./BCFViewerStore";

export const BCFViewerModel: React.FC = observer(() => {
  const columns: TableColumnProps<API_IfcFile>[] = [
    {
      dataKey: "filenameFromXml",
      label: i18n.t("Model name", { ns: I18N_NS.PROJECT }) as string,
      flexGrow: 1,
      width: 180,
    },
    {
      dataKey: "creationDate",
      label: i18n.t("Creation date", { ns: I18N_NS.PROJECT }) as string,
      width: 150,
    },
  ];
  return (
    <div className="bcf-model-container">
      <ScrollableTable<API_IfcFile>
        stretchHeight={true}
        rowKey="ifcProject"
        defaultSortBy="filenameFromXml"
        defaultSortDirection="ASC"
        columns={columns}
        data={bcfViewerStore.activeIcfFiles}
      />
    </div>
  );
});
